import { render } from "./AccountBankCreate.vue?vue&type=template&id=827524fa"
import script from "./AccountBankCreate.vue?vue&type=script&lang=js"
export * from "./AccountBankCreate.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__